import React, { useMemo, useRef, useEffect } from 'react'
import { IonList } from '@ionic/react'
import { FormProps } from './Form.types'
import { renderPage } from './Form.renderers'

const Form: React.FC<FormProps> = ({ data, value, onChange, className, filter, disabledFields }) => {
  const pages = useMemo(() => data.pages ?? [], [data])
  const valueRef = useRef(value)

  useEffect(() => {
    valueRef.current = value
  }, [value])

  const stableOnChange = React.useCallback(
    (newValue: typeof value) => {
      onChange(newValue)
    },
    [onChange]
  )

  return (
    <IonList id='SpecialReportForm' className={className}>
      {pages.map((page, pageIndex) =>
        renderPage(page, pageIndex, value, stableOnChange, valueRef, filter, disabledFields)
      )}
    </IonList>
  )
}

export default Form
